// extracted by mini-css-extract-plugin
module.exports = {"infoTitle":"styles_infoTitle__1onGY","line":"styles_line__zEoPQ","greyLabel":"styles_greyLabel__3m6a2","totalLabel":"styles_totalLabel__16yCp"};